export default __webpack_public_path__ + "static/media/path7.6c6a7ad4.svg";